// "@username as Character" credit line. Username uses the Discord Survivor green.
export default function PhotoCredit({ item, className = "", testid }) {
  const name = item.submitter_username || item.submitter_global_name;
  if (!name) return <span className={className} data-testid={testid}>Anonymous</span>;
  return (
    <span className={className} data-testid={testid}>
      <span className="text-[#1ABC9C] font-semibold normal-case tracking-normal">@{name}</span>
      {item.character_name && (
        <span className="text-[#E2E4DF]/80">
          {" "}as <span className="text-[#E2E4DF]">{item.character_name}</span>
        </span>
      )}
    </span>
  );
}
